import { Component, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-vidplayer',
  templateUrl: './vidplayer.component.html',
  styleUrl: './vidplayer.component.scss'
})
export class VidplayerComponent {

  @Input() videoUrl: string = '';
  @ViewChild('videoPlayer') videoPlayer: any; 
  isPlaying = false; 
  volume = 50; 
  progress = 0;
  currentTime = 0;
  duration = 0; 

  togglePlayPause(): void {
    if (this.videoPlayer.nativeElement.paused) {
      this.videoPlayer.nativeElement.play();
      this.isPlaying = true;
    } else {
      this.videoPlayer.nativeElement.pause();
      this.isPlaying = false;
    }
  }
  padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }


  public get durationString() : string{
    const minutes = Math.floor(this.currentTime / 60);
    const seconds = Math.floor(this.currentTime % 60);
    return `${this.padZero(minutes)}:${this.padZero(seconds)}`;

  }
  onTimeUpdate(video: HTMLVideoElement): void {
    this.currentTime = this.videoPlayer.nativeElement.currentTime;
    this.progress = (this.currentTime / video.duration) * 100;
  }

  onMetadataLoaded(video: HTMLVideoElement): void {
    console.log("video meta data is loaded")
    this.duration = video.duration;
  }

 
  onProgressBarClick(event: MouseEvent, video: HTMLVideoElement): void {
    const progressBar = event.target as HTMLElement;
    const clickedPosition = (event.offsetX / progressBar.clientWidth) * video.duration;
    video.currentTime = clickedPosition;
  }


  onVolumeChange(): void {
    this.videoPlayer.nativeElement.volume = this.volume / 100; 
  }

}
